<template>
  <div>
    <v-container fluid>
      <!-- <div class="mb-2">
        <div class="primary--text">{{ $t('order_statistics') }}</div>
      </div> -->
      <v-layout class="mb-2" wrap>
        <v-flex v-if="isTcpMainPage" xs6 class="pb-2">
          <multiselect
            v-model="filterTcpPage"
            :options="tcpPageOptions"
            select-label
            selected-label
            placeholder="เลือกเพจ"
            label="page_name"
            style="margin-bottom: 4px"
            @input="handleFetchData"
          ></multiselect>
        </v-flex>
        <v-flex xs12>
          <DashboardSelectChannel v-model="filter" @changeChannel="handleFetchData" />
        </v-flex>
        <v-flex xs12>
          <date-filter
            v-model="selectedDate"
            :show-time="false"
            @onSelected="handleFetchData"
          ></date-filter>
        </v-flex>
      </v-layout>
      <v-divider />
      <div v-if="loading" class="text-xs-center" style="padding-top: 64px">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <template v-else>
        <v-layout wrap class="mt-4">
          <v-flex xs12 sm9>
            <v-layout wrap>
              <v-flex xs12 sm4 class="pr-3">
                <v-card color="grey lighten-4" class="px-2 py-3">
                  <div class="caption">จังหวัด:</div>
                  <div class="mb-3">
                    <multiselect
                      v-model="filterProvince"
                      :options="provinceOptions"
                      select-label
                      selected-label
                      placeholder="เลือกจังหวัด"
                      :multiple="true"
                      style="margin-bottom: 4px"
                    ></multiselect>
                  </div>
                  <div class="caption">สถานะออเดอร์:</div>
                  <div>
                    <v-radio-group v-model="order_complete" row hide-details class="mt-0">
                      <v-radio label="สำเร็จ" :value="true" color="primary"></v-radio>
                      <v-radio label="ไม่สำเร็จ" :value="false" color="primary"></v-radio>
                    </v-radio-group>
                  </div>
                  <div class="text-xs-center mt-3">
                    <v-btn color="primary" class="ma-0" small @click="handleFetchData">
                      <em class="fas fa-search mr-1" />
                      ดูข้อมูล
                    </v-btn>
                  </div>
                </v-card>
              </v-flex>
              <v-flex xs12 sm4 class="pr-3">
                <v-card
                  color="grey lighten-4"
                  class="pa-2 text-xs-center"
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    height: 100% !important;
                  "
                >
                  <div>
                    จำนวน
                    <span class="primary--text" style="font-size: 18px">{{
                      (data && data.total_orders) || 0
                    }}</span>
                    ออเดอร์
                  </div>
                  <div class="mt-3">
                    ราคา
                    <span class="primary--text" style="font-size: 18px">
                      <template v-if="data && data.total_orders_amount > 0">
                        {{ data.total_orders_amount | numberFormat }}
                      </template>
                      <template v-else> 0 </template>
                    </span>
                    บาท
                  </div>
                </v-card>
              </v-flex>
              <v-flex xs12 sm4 class="pr-3">
                <v-card
                  color="grey lighten-4"
                  class="pa-2 fill-height text-xs-center"
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    height: 100% !important;
                  "
                >
                  <div>ระยะเวลาในการทำรายการ<br />ต่อ 1 ออเดอร์ที่สำเร็จ</div>
                  <div class="mt-3">
                    <template v-if="data && data.average_transaction_order_complete_time">
                      <span class="primary--text">{{
                        transformToTime(data.average_transaction_order_complete_time)
                      }}</span>
                    </template>
                    <template v-else>0</template>
                  </div>
                </v-card>
              </v-flex>
              <v-flex xs12 sm12 class="pr-3 pt-3">
                <OrderStatisticsChart v-if="data" v-model="data" />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm3>
            <v-card color="grey lighten-4" class="pa-2 fill-height" style="height: 100% !important">
              <div class="text-xs-center">
                <div class="primary--text">
                  {{ selectedDate.start | DateFormat('DD/MM/YYYY') }}
                  <span class="px-1">-</span>
                  {{ selectedDate.end | DateFormat('DD/MM/YYYY') }}
                </div>
                <div class="primary--text">
                  {{ currentFilterStatus ? 'สำเร็จ' : 'ไม่สำเร็จ' }}ทั้งหมด
                  {{ (data && data.total_orders) || 0 }} รายการ
                </div>
              </div>
              <div class="mt-3">
                <template v-if="Object.keys(filterProvinceOrders).length > 0">
                  <template v-for="(item, index) in Object.entries(filterProvinceOrders)">
                    <div :key="`province-${index}`">
                      <v-layout wrap>
                        <v-flex xs7 class="text-xs-right">{{ item[0] }} :</v-flex>
                        <v-flex xs5 class="pl-2">{{ item[1] }} รายการ</v-flex>
                      </v-layout>
                    </div>
                  </template>
                </template>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
        <div class="mt-5 text-xs-right">
          <OrderStatisticsList v-model="filterOrders" />
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import { PAGE } from '@/constants/page.js'
import Multiselect from 'vue-multiselect'
import tcpApi from '@/api/tcp'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter'
import DashboardSelectChannel from '@/components/view/dashboard/DashboardSelectChannel.vue'
import OrderStatisticsChart from './OrderStatisticsChart.vue'
import OrderStatisticsList from './OrderStatisticsList.vue'
import province from '@/data/province.js'

export default {
  components: {
    DateFilter,
    Multiselect,
    DashboardSelectChannel,
    OrderStatisticsChart,
    OrderStatisticsList
  },
  data() {
    return {
      loading: false,
      filter: 'all',
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      filterTcpPage: '',
      order_complete: true,
      data: null,
      provinceOptions: province,
      filterProvince: [],
      currentFilterStatus: true
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    tcpPageOptions() {
      return this.$store.state.tcpSubpages || []
    },
    isTcpMainPage() {
      return PAGE.TCP_MAIN_PAGE.includes(this.selectedBot.pageid)
    },
    isTcpSubpage() {
      return PAGE.TCP_SHOP_SERVICES.includes(this.selectedBot.pageid)
    },
    filterOrders() {
      let orders = []
      if (this.data) {
        if (this.data) {
          orders = this.order_complete ? this.data.order_complete : this.data.order_not_complete
        }
      }

      return orders
    },
    filterProvinceOrders() {
      let provinceOrders = {}
      if (this.data) {
        provinceOrders = this.currentFilterStatus
          ? this.data.province_order_complete
          : this.data.province_order_not_complete
      }
      return provinceOrders
    }
  },
  mounted() {
    if (this.isTcpMainPage && !this.$store.state.tcpSubpages) {
      this.$store.dispatch('getTcpSubpages')
    }

    this.handleFetchData()
  },
  methods: {
    async handleFetchData() {
      const vm = this
      try {
        vm.currentFilterStatus = vm.order_complete
        const data = {
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
          app: vm.filter,
          order_complete: vm.order_complete,
          provinces: vm.filterProvince
        }

        if (vm.isTcpMainPage) {
          Object.assign(data, {
            master_page_id: vm.selectedBot.pageid,
            page_id: vm.filterTcpPage ? vm.filterTcpPage.page_id : vm.selectedBot.pageid
          })
        } else {
          Object.assign(data, {
            page_id: vm.selectedBot.pageid
          })
        }

        // vm.$store.dispatch('loading')
        vm.loading = true
        const response = await vm.getTcpOrderStatistics(data)
        vm.loading = false
        // vm.$store.commit('CLEAR_LOADING')

        if (response && response.status === 200 && response.data) {
          vm.data = response.data.data
        }
      } catch (error) {
        vm.loading = false
        // vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async getTcpOrderStatistics(payload) {
      try {
        const response = await tcpApi.postGetOrderStatistics({ data: payload })
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    transformToTime(time) {
      const tempTime = Number(time)
      const hour = Math.floor(tempTime / 3600)
      const minute = Math.floor((tempTime % 3600) / 60)
      const second = Math.floor((tempTime % 3600) % 60)

      const hDisplay = hour > 0 ? `${hour} ชั่วโมง` : ''
      const mDisplay = minute > 0 ? ` ${minute} นาที` : ''
      const sDisplay = second > 0 ? ` ${second} วินาที` : ''
      return `${hDisplay} ${mDisplay} ${sDisplay}`
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/OrderStatistics/OrderStatistics.vue